export function queryParamsToString(params: Record<string, string | undefined> = {}): string {
  const urlParams = new URLSearchParams()
  Object.entries(params)
    .filter(([, value]): boolean => Boolean(value))
    .forEach(([key, value]) => urlParams.set(key, value as string))
  return urlParams.toString()
}
